export default __webpack_public_path__ + "static/media/warning--tractors--g7.c9d9396b.png";